import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
body {
  font-family:'Roboto', 'Times New Roman', Times, serif;
  background-color: #F9F9F9;
  min-height: 100vh;
  max-width: 100vw;
}
`;
export default GlobalStyle